import { BusinessLineRequest } from '@cemex-core/cmx-api/models/business-lines/business-lines-request';
import { createAction, props } from '@ngrx/store';
import { CxProductType } from '../../models/product-type';

export const resetState = createAction('[PRODUCT_TYPE] Reset State');
export const resetEntityState = createAction('[PRODUCT_TYPE] Reset Entity', props<{ id: string }>());
export const updateEntity = createAction('[PRODUCT_TYPE] Update Entity', props<{ payload: CxProductType }>());
export const updateEntities = createAction('[PRODUCT_TYPE] Update Entities', props<{ payload: CxProductType[] }>());
export const selectEntity = createAction('[PRODUCT_TYPE] Select Entity', props<{ id: string }>());

export const fetchEntity = createAction('[PRODUCT_TYPE] Fetch Entity start', props<BusinessLineRequest>());

export const CxProductTypeActions = {
  resetState,
  resetEntityState,

  updateEntity,
  updateEntities,
  selectEntity,

  fetchEntity,
};

export default CxProductTypeActions;
